import React from 'react'
import './printcard.css'
import { Link } from 'react-router-dom'


const PrintCard = ({style, imgSrc, link, imgStyle, to}) => {
  return <div style={style} className='print__card-item'>
    <Link to={to}>
        <img style={imgStyle} className='print__card-image' src={imgSrc} alt="" />
    </Link>
    <Link to={to} className='print__card-link'>{link}</Link>
    <span className='print__card-category'>Prints</span>
  </div>
}

export default PrintCard